import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { SubdomainRoutingService } from './core/services/Motor_leasing/subdomain-routing.service';
import { AuthService } from './core/services/Motor_leasing/auth.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit{
  constructor(
    private readonly subdomainService: SubdomainRoutingService,
    private readonly authService: AuthService,
    private readonly router: Router
  ) { }


ngOnInit() {
  const subdomain = this.subdomainService.getSubdomain();
  const user = this.authService.getUser();
  const isAuthenticated = this.authService.isAuthenticated();

  let currentUrl: any;
  setInterval(() => {
    currentUrl = this.router.url;
  }, 100);

  if (subdomain === 'fleet') {
    this.handleFleet();
  } else if (subdomain === 'health') {
    this.handleHealth();
  } else if (isAuthenticated && user) {
    this.handleAuthenticatedUser(user, subdomain);
  } else {
    this.handleUnauthenticatedUser(subdomain, currentUrl);
  }
}


private handleFleet(): void {
  this.router.navigate(['/motor-sme']);
}

private handleHealth(): void {
  this.router.navigate(['/medical-sme']);
}

private handleAuthenticatedUser(user: any, subdomain: string): void {
  if (user.role === 'TtAdmin' && subdomain === 'admin') {
    this.router.navigate(['/admin']);
  } else if ((user.role === 'LessorAdmin' || user.role === 'LessorProxyAdmin') && subdomain !== 'admin') {
    this.router.navigate(['/lessor']);
  } else if (user.role === 'Lessee') {
    this.router.navigate(['/lessee-dashboard']);
  } else if (user.role === 'TtUser') {
      console.log(user.role);
  } else {
    this.authService.logout('admin');
    this.router.navigate(['/unauthorized']);
  }
}

private handleUnauthenticatedUser(subdomain: string, currentUrl: string): void {
  if (subdomain === 'admin') {
    this.router.navigate(['/admin-login']);
  } else {
    this.verifyTenant(subdomain, currentUrl);
  }
}

private verifyTenant(subdomain: string, currentUrl: string): void {
  this.subdomainService.verifyTenant().subscribe({
    next: (response) => {
      if (response.isSuccess && response.data.some((item: string) => item.toLowerCase() === subdomain.toLowerCase())) {
        this.router.navigate(['/lessor-login']);
      } else if (currentUrl.includes('motor-Insurance')) {
        this.router.navigate(['/lessee/home/motor-Insurance']);
      } else if (currentUrl.includes('motor-sme')) {
        this.router.navigate(['motor-sme']);
      } else if (currentUrl.includes('lessee-policy')) {
        this.router.navigate(['lessee/home/lessee-policy']);
      } else {
        this.router.navigate(['/lessee-dashboard']);
      }
    },
    error: () => {
      this.router.navigate(['/unauthorized']);
    }
  });
}



}
